import { Box, Checkbox, FormControlLabel, Grid, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AHMIS, { API_URL } from '../../../api/api';
import AddAlertMessage from '../../../components/alert/Alert';
import CustomReactSelect from '../../../components/custom-react-select/CustomReactSelect';
import DeleteRegisterRecordConformation from '../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation';
import CustomModal from '../../../components/modal/CustomModal';
import AddMedicineList from '../../../components/add-medicine-list/AddMedicineList';
import MulDartaaSelect from '../../../components/mul-dartaa-select/MulDartaaSelect';
import PendingPatientList from '../../../components/pending-patient-list/PendingPatientList';
import RegisterHeader from '../../../components/register-header/RegisterHeader';
import { AppMisc } from '../../../misc/appMisc';
import { AppUtils } from '../../../utils/appUtils';
import { AYURVEDIC_THERAPY, ERROR, OUTPATIENT, REQUIRED_FIELD, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants';
import { ICD_CODE_OPTIONS, INVALID_BLOOD_PRESSURE_MESSAGE, MUL_DARTA_NUMBERS_LIST } from '../../../utils/constants/forms';
import { DateUtils } from '../../../utils/dateUtils';
import { SessionStorage } from '../../../utils/storage/sessionStorage';
import OutPatientRegister from '../../users/components/register/out-patient-register/OutPatientRegister';
import NepaliCalender from "../../../components/nepali-calender";
import styles from "./style";

const OutPatientForm = () => {
  const [modalTitle, setModalTitle] = useState("बहिरङ्ग सेवा रजिष्टरमा नयाँ रेकर्ड थप्नुहोस्।");
  const [showOutPatientModal, setShowOutPatientModal] = useState(false)
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch, control } = useForm();
  const [totalSize, setTotalSize] = useState();
  const [OpdDataTable, setOpdDataTable] = useState([]);
  const [showOpdDeleteModal, setShowOpdDeleteModal] = useState(false);
  const [opdDeleteId, setOpdDeleteId] = useState(null);
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const [pendingPatientList, setPendingPatientList] = useState([])
  const [medicineDetails, setmedicineDetails] = useState([])
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);
  const classes = styles();

  useEffect(() => {
    register("genderViolence")
    register("followUpDate");
  }, [register]);

  const openOutPatientModal = () => {
    setShowOutPatientModal(true);
  }

  const closeOutPatientModal = () => {
    reset({
      icdCode: [],
      labTests: '',
      provisionalDiagnosis: '',
      ayurvedicTherapy: [],
      tratementAndSuggestion: '',
      referredIn: '',
      referredOut: '',
      genderViolence: "",
      patientFirstName: '',
      patientLastName: '',
      age: '',
      gaunOrTole: '',
      nid: '',
      phoneNumber: '',
      wardNumber: '',
      temperatureInFahrenheit: "",
      temperature: "",
      pulseRate: "",
      respPerMin: "",
      bloodPressure: "",
      spO2: "",
      sewaDartaaNumber: "",
      followUpDate: "",
      familyHistory: "",
      personalHistory: "",
      allergicHistory: "",
      healthWorkerName: "",
      complaint: ""

    });
    setShowOutPatientModal(false);
    setModalDefaultValues()
    setmedicineDetails([])
  }

  const handleCustomReactSelectChange = (name, value) => {
    if (name === "icdCode") {
      // Find the corresponding value from ICD_CODE_OPTIONS based on the label
      const selectedValue = ICD_CODE_OPTIONS
        .flatMap((type) => type.options) // Flatten the nested array of options into a single array
        .find((option) => option.label === value)?.value || value; // Find the option where the label matches the selected value and extract the corresponding value
      // Set the selected value for the "icdCode" field
      setValue(name, selectedValue);
    } else {
      // For other fields, set the value as is
      setValue(name, value);
    }
  };

  const submitOpdForm = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    data.medicineDetails = medicineDetails;
    AHMIS.post(API_URL.outPatient, data)
      .then((response) => {
        if (response.data.type === "success") {
          closeOutPatientModal()
          opdPendingPatient()
          getOutPatientData(fromDate, toDate)
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message })
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };


  useEffect(() => {
    if (fromDate && toDate) {
      getOutPatientData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage])

  const getOutPatientData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.outPatient}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(pageNumber))}&rowSize=${rowsPerPage}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setOpdDataTable(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.size)
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  useEffect(() => {
    opdPendingPatient()
  }, [])

  const opdPendingPatient = () => {
    let url = `${API_URL.pendingPatient}?sewaType=${"1"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&registerConstant=${OUTPATIENT}`
    AHMIS.get(url).then((response) => {
      let jsondata = response.data;
      setPendingPatientList(jsondata.data)
    })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const opdEdit = async (id) => {
    try {
      const response = await AHMIS.get(API_URL.outPatient + "/" + id);
      const data = response?.data?.data;
      data.icdCode = AppMisc.getLabelFromValues(ICD_CODE_OPTIONS, data.icdCode);
      // Set modal default values
      setModalDefaultValues(data);
      setmedicineDetails(data?.medicineDetails)
      setShowOutPatientModal(true);
      // Populate form values dynamically
      if (data) {
        Object.keys(data).forEach(key => {
          setValue(key, data[key]); // This will set the value for each field dynamically
        });
      }
    } catch (error) {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    }
  };


  const closeMulDartaaDeleteModal = () => {
    setShowOpdDeleteModal(false);
    setOpdDeleteId(null);
  }

  const onDeleteOpdRow = (id) => {
    setShowOpdDeleteModal(true);
    setOpdDeleteId(id);
  }

  const deleteOutPatientRow = (data) => {
    AHMIS.delete(API_URL.outPatient + "/" + opdDeleteId + "?deleteReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowOpdDeleteModal(false);
          setOpdDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getOutPatientData(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const setFahrenheitValue = (celsiusValue) => {
    if (celsiusValue === "") {
      setValue("temperatureInFahrenheit", "");
    } else {
      setValue("temperatureInFahrenheit", AppUtils.celsiusToFahrenheit(celsiusValue));
    }
  };

  const setCelsiusValue = (fahrenheitValue) => {
    if (fahrenheitValue === "") {
      setValue("temperature", "");
    } else {
      setValue("temperature", AppUtils.fahrenheitToCelsius(fahrenheitValue));
    }
  };

  // const handleChecked = (e) => {
  //   setValue("genderViolence", e.target?.checked);
  // };

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    getOutPatientData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?sewaType=1&fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }

  useEffect(() => {
    attachMulDartaaOptions();
  }, [])

  return (
    <>
      <Box marginTop={3}>
        <RegisterHeader
          registerTitle="बहिरङ्ग सेवा रजिष्टर"
          handleModalOpen={openOutPatientModal}
          onHeaderParamChange={onHeaderParamChange}
          getRegisterData={getOutPatientData}
          lazyLoading
          showSearchField
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showOutPatientModal}
        onModalSubmit={handleSubmit(submitOpdForm)}
        onModalClose={closeOutPatientModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <MulDartaaSelect
            mulDartaaOptions={mulDartaaOptions}
            defaultValues={modalDefaultValues}
            register={register}
            handleSubmit={handleSubmit}
            setValue={setValue}
            errors={errors}
            watch={watch}
            registerConstant={OUTPATIENT}
          />
        </Grid>
        <Box marginTop={2}>
          <Typography variant="h6">Vitals</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Temperature(°F)"
                type="number"
                // defaultValue={modalDefaultValues.temperatureInFahrenheit}
                size="small"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="temperatureInFahrenheit"
                {...register("temperatureInFahrenheit")}
                onChange={(e) => {
                  setCelsiusValue(e.target.value);
                }}
                inputProps={{ min: 0 }}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Temperature(°C)"
                type="number"
                size="small"
                variant="outlined"
                // defaultValue={modalDefaultValues.temperature}
                InputLabelProps={{ shrink: true }}
                name="temperature"
                {...register("temperature")}
                onChange={(e) => {
                  setFahrenheitValue(e.target.value);
                }}
                inputProps={{ min: 0 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Pulse Rate"
                // defaultValue={modalDefaultValues.pulseRate}
                type="number"
                size="small"
                variant="outlined"
                name="pulseRate"
                {...register("pulseRate")}
                inputProps={{ min: 0 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Resp / Min"
                // defaultValue={modalDefaultValues.respPerMin}
                type="number"
                size="small"
                variant="outlined"
                name="respPerMin"
                {...register("respPerMin")}
                inputProps={{ min: 0 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Blood Pressure"
                defaultValue={modalDefaultValues?.bloodPressure}
                type="text"
                size="small"
                variant="outlined"
                name="bloodPressure"
                {...register("bloodPressure", {
                  pattern: {
                    value: /^(0|[1-9][0-9]*)\/(0|[1-9][0-9]*)$/,
                    message: INVALID_BLOOD_PRESSURE_MESSAGE
                  }
                })}
                fullWidth
              />
              {errors.bloodPressure && errors.bloodPressure.type === "pattern" && <span className="error-message">{INVALID_BLOOD_PRESSURE_MESSAGE}</span>}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="SpO2 Level"
                // defaultValue={modalDefaultValues.spO2}
                type="number"
                size="small"
                variant="outlined"
                name="spO2"
                {...register("spO2")}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
        <Box marginTop={2}>
          <Typography variant="h6">History</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                label="Family History"
                name="familyHistory"
                size="small"
                variant="outlined"
                defaultValue={
                  modalDefaultValues?.familyHistory
                }
                {...register("familyHistory")}
                multiline
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                label="Personal History"
                name="personalHistory"
                size="small"
                variant="outlined"
                defaultValue={
                  modalDefaultValues?.personalHistory
                }
                {...register("personalHistory")}
                multiline
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                label="Allergic History"
                name="allergicHistory"
                size="small"
                variant="outlined"
                defaultValue={
                  modalDefaultValues?.allergicHistory
                }
                {...register("allergicHistory")}
                multiline
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
        <Box marginTop={2}>
          <Typography variant="h6">General Examination</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3} style={{ overflowY: 'auto' }}>
              <CustomReactSelect
                label="ICD Code"
                name="icdCode"
                onChange={handleCustomReactSelectChange}
                options={ICD_CODE_OPTIONS}
                defaultValue={modalDefaultValues?.icdCode}
                register={register}
                isMulti
                hasMultiLevelObject
                required
              />
              {errors?.icdCode && errors.icdCode?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Grid>
            <Grid item xs={12} sm={6} md={3} style={{ overflowY: 'auto' }}>
              <TextField
                label="निदानात्मक परीक्षण"
                size="small"
                variant="outlined"
                name="labTests"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.labTests}
                {...register("labTests")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="सम्भावित निदान"
                size="small"
                variant="outlined"
                name="provisionalDiagnosis"
                autoComplete="true"
                defaultValue={modalDefaultValues?.provisionalDiagnosis}
                fullWidth
                {...register("provisionalDiagnosis")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <CustomReactSelect
                label="सेवाको प्रकार"
                name="ayurvedicTherapy"
                onChange={handleCustomReactSelectChange}
                options={AYURVEDIC_THERAPY}
                defaultValue={modalDefaultValues?.ayurvedicTherapy}
                creatable
                isMulti
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="उपचार र सल्लाह"
                size="small"
                variant="outlined"
                name="tratementAndSuggestion"
                autoComplete="true"
                defaultValue={modalDefaultValues?.tratementAndSuggestion}
                fullWidth
                {...register("tratementAndSuggestion")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई आएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredIn"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredIn}
                fullWidth
                {...register("referredIn")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई गएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredOut"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredOut}
                fullWidth
                {...register("referredOut")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <Tooltip title="लैङ्गिक हिंसा भए मात्र यो कोठामा चिन्ह लगाउनुहोस ।" placement="top" arrow>
                <Controller
                  name="genderViolence"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      label="लैङ्गिक हिंसा"
                      control={
                        <Checkbox {...field} checked={field.value} color="primary" />
                      }
                    />
                  )}
                />
              </Tooltip>
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <Box className="postion-relative">
                <NepaliCalender
                  id="followUp-Date"
                  name="followUpDate"
                  onChange={handleDateChange}
                  label="फर्केर आउने मिति"
                  defaultDate={modalDefaultValues?.followUpDate}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="जाँच गर्ने स्वास्थ्यकर्मीको नाम"
                size="small"
                variant="outlined"
                name="healthWorkerName"
                autoComplete="true"
                defaultValue={modalDefaultValues?.healthWorkerName}
                fullWidth
                {...register("healthWorkerName")}
              />
            </Grid>
          </Grid>
          <Box className={classes.subTitle} mt={2}>
            <Typography variant="h6">सिकायत/लक्षण तथा चिन्हहरु </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs>
              <TextField
                label="सिकायत (लक्षण तथा चिन्हहरु)"
                size="small"
                variant="outlined"
                name="complaint"
                autoComplete="true"
                defaultValue={modalDefaultValues?.complaint}
                fullWidth
                {...register("complaint")}
              />
            </Grid>
          </Grid>
          <Box className={classes.subTitle} mt={2}>
            <Typography variant="h6">औषधि विवरण <span className={classes.hintMessage}>[नोट: औषधि विवरणहरू प्रदान गरेपछि ADD TO LIST लेखिएको बटनमा क्लिक गर्नुहोस्।]</span></Typography>
          </Box>
          <Grid item xs={12}>
            <AddMedicineList
              medicineDetails={medicineDetails}
              onAddmedicineDetails={(data) => setmedicineDetails(data)}
            />
          </Grid>
        </Box>
      </CustomModal>
      {
        pendingPatientList?.totalSize > 0 &&
        <Box mt={2}>
          <PendingPatientList
            pendingPatientList={pendingPatientList}
            showModal={setShowOutPatientModal}
            modalDefaultValues={setModalDefaultValues}
            setValue={setValue}
          />
        </Box>
      }
      <DeleteRegisterRecordConformation
        showDeleteModal={showOpdDeleteModal}
        closeDeleteModel={closeMulDartaaDeleteModal}
        deleteRecord={deleteOutPatientRow}
      />
      <Box mt={2}>
        <OutPatientRegister
          onEditRow={opdEdit}
          tableData={OpdDataTable}
          deleteRow={onDeleteOpdRow}
          totalSize={totalSize}
        />
      </Box>
    </>
  )
}

export default OutPatientForm;